<!-- 缴费接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkingCode": "180410135558832886170666",
                "chargeDate": "20180411135558",
                "payDate": "20180411135658",
                "actPayCharge": "3.2",
                "payOrigin": "9",
                "payOriginRemark": "微信",
                "paymentMode": "4",
                "paymentModeRemark": "微信支付",
                "billCode": "0",
                "couponList": ""
            },
            responseCode: {
                "data": {
                    "parkCode": "2KKN6111",
                    "timeoutLength": 2,
                    "ydtBillCode": "2017112416141742352669"
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统同步用户缴费信息到智慧停车开放平台（请在查费(getParkFee)后10分钟内完成缴费操作）",
                t_url: this.commonUrls.test + "payParkFee",
                p_url: this.commonUrls.prod + "payParkFee",
                precondition: {
                    preData: "在调用接口",
                    link:  "查费",
                    url: "getParkFee",
                    endData: "后10分钟内完成本接口调用"
                },
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号（根据查费时返回的parkingCode回传）' },
                        { info1: 'chargeDate', info2: '是', info3: 'String', info4: '计费时间（回传查费时返回的计费时间chargeDate），yyyyMMddHHmmss' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                        { info1: 'actPayCharge', info2: '是', info3: 'Decimal', info4: '车主实付，元' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源（<url>参考附录:/Api/appendixData#appendixData_1</url>）' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'int', info4: '支付方式（<url>参考附录:/Api/appendixData#appendixData_0</url>）' },
                        { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'collectorName', info2: '否', info3: 'String', info4: '收费员名称（vems车场可统一定义有意义的名称，便于财务人员对账）' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方系统缴费订单号，每条账单唯一（缴费失败，再次缴费时，该账单号要与首次缴费的一致），用于重复同步时判断重复和对账（不超过32位）' },
                        { info1: 'couponList', info2: '否', info3: 'JsonArray', info4: '缴费优惠金额，可配合查费时的查询优惠使用（可直接将查费接口响应couponList赋予此值）' },
                        { info1: 'prestoreForFirstPayThenLeave', info2: '否', info3: 'int', info4: '先付费后离场付费标识，不传或者为非1均无效。应用场景：实现预付费先付费后离场逻辑（免密支付场景），调用setPrestoreForFirstPayThenLeave，车辆预出场时，收费系统调用payUrl实现扣费逻辑后，调用缴费接口，该字段设置为1' },
                        // { info1: 'traderCouponList', info2: '否', info3: 'JsonArray', info4: '先付费后离场智慧停车电子券核销标识，仅当prestoreForFirstPayThenLeave=1时有效。应用场景：实现预付费先付费后离场逻辑（免密支付场景），调用setPrestoreForFirstPayThenLeave，车辆预出场时，收费系统调用payUrl实现扣费逻辑时，含有参数trader_coupon_list，调用缴费接口同步账单到车场时，设置该字段' },
                        { info1: 'otherAtrr', info2: '否', info3: 'JSONObject', info4: '对应查费时的otherAttr' },
						{ info1: 'openId', info2: '否', info3: 'String', info4: 'openId，无实际意义，仅作为传输使用，仅作为临停缴费上报otherAttr的一个属性' },
                        { info1: 'bankType', info2: '否', info3: 'String', info4: '付款银行(微信支付添加)' },
                        { info1: 'receiveAccount', info2: '否', info3: 'String', info4: '到账商户号' },

                    ]
                },{
                    titleName: 'couponList：（目前只支持传输一个）注意缴费时 优惠中的couponValue+actPayCharge=查费返回的shouldPayValue',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
                        { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '抵扣金额' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠编码（长度不超过32位）' },
                        { info1: 'reliefType', info2: '是', info3: 'int', info4: '减免类型，券类型(0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)' },
                        { info1: 'faceValue', info2: '是', info3: 'Decimal', info4: '面值，金额券单位：元，如：1 表示1元；折扣填0~1,时间券单位：分钟， 如：1 表示1分钟' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ydtBillCode', info2: '是', info3: 'String', info4: '智慧停车账单编号' },
                        { info1: 'timeoutLength', info2: '是', info3: 'int', info4: '缴费后免费时长，单位秒' }
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/payParkFee.vue